import styles from './RouteFallback.module.css';

/** Lightweight loading indicator shown while a lazy route loads. */
export function RouteFallback() {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      <span className="visually-hidden">Loading…</span>
    </div>
  );
}
